import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, ref, watch } from 'vue';
import { knownServices } from '@/modules/onboarding/signup/helpers/email-suggester';


export default /*#__PURE__*/_defineComponent({
  __name: 'AutoCompleteSelector',
  props: {
  email: {
    type: String,
    default: ''
  }
},
  emits: ['update-email'],
  setup(__props, { emit }) {

const props = __props;

const emailDomainArray = ref<string[]>([]);
const closedByClick = ref<boolean>(false);





function updateEmail(value: string) {
  const email = props.email.split('@');
  emit('update-email', `${email[0]}${value}`);
}

const displaySelect = computed(() => {
  const emailDomain = emailDomainArray.value.find(domain =>
    props.email.includes(domain)
  );
  return (
    props.email.includes('@') &&
    !props.email.includes('.com') &&
    !emailDomain &&
    !closedByClick.value &&
    emailDomainArray.value.length > 0
  );
});

function toggleClose() {
  closedByClick.value = !closedByClick.value;
}

watch(
  () => displaySelect.value,
  newValue => {
    if (newValue) {
      document.body.addEventListener('click', toggleClose);
    } else {
      document.body.removeEventListener('click', toggleClose);
    }
  }
);
watch(
  () => props.email,
  () => {
    closedByClick.value = false;
    emailDomainArray.value = knownServices
      .filter(entry =>
        entry.domain.includes(props.email.toLowerCase().split('@')[1])
      )
      .map(entry => `@${entry.domain}`);
    if (emailDomainArray.value.includes('')) {
      emailDomainArray.value = knownServices.map(entry => `@${entry.domain}`);
    }
  }
);
onMounted(() => {
  knownServices.forEach(entry => {
    emailDomainArray.value.push(`@${entry.domain}`);
  });
});

return { __sfc: true,emailDomainArray, closedByClick, props, emit, updateEmail, displaySelect, toggleClose }
}

})